import Polygon from "@arcgis/core/geometry/Polygon";
import { createAction } from "@reduxjs/toolkit";

export const setEditingBorders = createAction<
  "reset" | "draw" | "resetAndDraw"
>("SET_EDITING_BORDERS");
export const editFeaturesOnMap = createAction<
  Map<number | string, Polygon>,
  "EDIT_FEATURES_ON_MAP"
>("EDIT_FEATURES_ON_MAP");
export const getGeometryForContour = createAction<{
  plotIdx: number;
  contourIdx: number;
}>("GET_GEOMETRY_FOR_CONTOUR");
export const setLayerVisibilityByEstateEn = createAction<{
  estateIds: number[];
}>("SET_LAYER_VISIBILITY_BY_ESTATE_EN");
